import { Component } from 'react';
import { interpolate } from 'd3-interpolate';

export default class Parawow extends Component {
  i = null;

  state = {
    value: 0,
  }

  componentDidMount() {
    const { style } = this.props;
    this.i = interpolate(style[0], style[1]);
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll = () => {
    const { scrollRange } = this.props;
    const [min, max] = scrollRange;
    const value = ((window.scrollY - min) / (max - min));
    this.setState({
      value
    })
  }
  render() {
    const { value } = this.state;
    const { style } = this.props;
    const i = interpolate(style[0], style[1]);
    const _style = i(value);
    return this.props.children(_style);
  }
}


// WEBPACK FOOTER //
// ./src/components/Parawow.js